<template>
  <div id="home-container" :class="playerActiveClass" ref="sectionHome" :style="textStyle">
    <div class="home-overlay" id="home-overlay"></div>
    <div class="home-muted-overlay" id="home-muted-overlay"></div>
    <div class="home-title" ref="home" id="home-title">
      <h1>SAMIR REHEM</h1>
    </div>
    <div class="home-title" id="home-muted-title">
      <h1>SAMIR REHEM</h1>
    </div>
    <!-- <div class="scroll-indicator" id="scroll-indicator">
      <div class="scroll-indicator-inner">
        <div id="home-indicator-pulse" class="scroll-indicator-pulse"></div>
        <div class="scroll-indicator-line"></div>
      </div>
    </div>-->
    <lottie
      class="scroll-indicator"
      id="scroll-indicator"
      :options="scrollDefaultOptions"
      :height="36"
      :width="36"
      v-on:animCreated="handleAnimation"
      v-scroll-to="'#section-collections'"
    />
    <lottie
      class="scroll-indicator"
      id="scroll-muted-indicator"
      :options="scrollDefaultOptions"
      :height="36"
      :width="36"
      v-on:animCreated="handleAnimation"
      v-scroll-to="'#section-collections'"
    />
    <div id="home-content">
      <div class="videoWrapper" v-if="videoID && videoID != ''" v-show="ready">
        <vueVimeoPlayer
          ref="player"
          :video-id="videoID"
          :options="options"
          :loop="true"
          @ready="onPlayerReady"
        ></vueVimeoPlayer>
      </div>
      <img v-if="bgImage && !ready" id="home-image" :src="bgImage" />
    </div>
    <div class="muteButton" @click="toggleMute()">
      <div :class="`muteButtonContents  ${muted ? '' : 'unmuted'}`">
        <img
          id="static-off-button"
          :src="require('@/assets/images/icons/volume-off-home.svg')"
          v-show="muted"
        />
        <img
          id="static-on-button"
          :src="require('@/assets/images/icons/volume-on-home.svg')"
          v-show="!muted"
        />
      </div>
    </div>
  </div>

  <!-- <div id="paralax-spacer"></div> -->
</template>

<script>
import { Fragment } from "vue-fragment";
import { mapState } from "vuex";
import { vueVimeoPlayer } from "vue-vimeo-player";
import { TweenLite } from "gsap/dist/gsap";
import * as ScrollMagic from "scrollmagic";
import { TimelineLite } from "gsap/all";
import { ScrollMagicPluginGsap } from "scrollmagic-plugin-gsap";
import { mapActions } from "vuex";
import { gsap, CSSPlugin } from "gsap/all";
import Lottie from "vue-lottie";
import * as scrollAnimationData from "@/assets/anim/scroll.json";

ScrollMagicPluginGsap(ScrollMagic, TimelineLite);
gsap.registerPlugin(CSSPlugin);

export default {
  name: "Home",
  components: {
    Fragment,
    vueVimeoPlayer,
    Lottie
  },
  computed: {
    ...mapState(["global"]),
    secondaryFontColor(){
      return `--green_font: ${this.$store.getters.themeSettings.secondary_font_color};`;
    },
    mainFontColor(){
      return `--main_font: ${this.$store.getters.themeSettings.main_font_color};`;
    },
    nameTitleFontSize(){
      return `--name_title_font_size: ${this.$store.getters.fontSettings.name.font_size}px;`;
    },
    nameTitleFontStyle(){
      return `--name_title_font_family: "${this.$store.getters.fontSettings.name.font_style}";`;
    },
    textStyle() {
      return `${this.secondaryFontColor} ${this.mainFontColor} ${this.nameTitleFontSize} ${this.nameTitleFontStyle}`;
    },
  },
  data() {
    return {
      videoID: "",
      ready: false,
      bgImage: null,
      options: {
        background: true,
        paused: true
      },
      playerReady: false,
      playerActiveClass: "",
      muted: true,
      tween: new TimelineLite({ paused: true }),
      scene: new ScrollMagic.Scene({
        triggerElement: this.$refs.sectionHome,
        triggerHook: "onLeave",
        duration: 500,
        offset: 0
      }),
      longScene: new ScrollMagic.Scene({
        triggerElement: this.$refs.sectionHome,
        triggerHook: "onLeave",
        duration: 1400,
        offset: 0
      }),
      longTween: new TimelineLite({ paused: true }),

      controller: new ScrollMagic.Controller(),
      scrollDefaultOptions: { animationData: scrollAnimationData.default },
      anim: null
    };
  },
  watch: {
    $route(to, from) {
      if (to.path.indexOf("collection") <= -1) {
        this.$refs.player.play();
        this.setPrevRouteExists(true);
      } else {
        this.$refs.player.pause();
      }
    }
  },
  methods: {
    handleAnimation: function(anim) {
      this.anim = anim;
    },

    stopAnimation: function() {
      this.anim.stop();
    },

    playAnimation: function() {
      this.anim.play();
    },

    pauseAnimation: function() {
      this.anim.pause();
    },

    onPlayerReady() {
      this.ready = true;

      if (this.$route.path.indexOf("collection") > -1) {
        this.$refs.player.pause();
      }
    },
    setLoading(isLoading) {
      //set loaded in vuex if necessary
    },
    toggleMute() {
      let scrollIndicator = document.getElementById("scroll-indicator");
      let overlay = document.getElementById("home-overlay");
      let overlayMuted = document.getElementById("home-muted-overlay");
      let titleName = document.getElementById("home-title");
      let homeMutedTitle = document.getElementById("home-muted-title");
      let scrollMutedIndicator = document.getElementById(
        "scroll-muted-indicator"
      );
      if (this.muted) {
        this.$refs.player.unmute();
        scrollIndicator.classList.add("hidden");
        overlay.classList.add("hidden");
        titleName.classList.add("hidden");
        overlayMuted.classList.add("visible");
        homeMutedTitle.classList.add("visible");
        scrollMutedIndicator.classList.add("visible");
      } else {
        this.$refs.player.mute();

        scrollIndicator.classList.add("with-transition");
        overlay.classList.add("with-transition");
        titleName.classList.add("with-transition");

        scrollIndicator.classList.remove("hidden");
        overlay.classList.remove("hidden");
        titleName.classList.remove("hidden");
        overlayMuted.classList.remove("visible");
        homeMutedTitle.classList.remove("visible");
        scrollMutedIndicator.classList.remove("visible");

        setTimeout(function() {
          scrollIndicator.classList.remove("with-transition");
          overlay.classList.remove("with-transition");
          titleName.classList.remove("with-transition");
        }, 600);
      }
      this.playerActiveClass = "active";

      this.muted = !this.muted;
    },

    addScrollMagicEffects() {
      const header = this.$refs.testAnchor;

      let homeTitle = document.getElementById("home-title");
      let homeMutedTitle = document.getElementById("home-muted-title");
      let scrollIndicator = document.getElementById("scroll-indicator");
      let scrollMutedIndicator = document.getElementById(
        "scroll-muted-indicator"
      );
      let homeOverlay = document.getElementById("home-overlay");
      let homeMutedOverlay = document.getElementById("home-muted-overlay");

      // homeTitle.style.transform = "translate(0%,0px)";
      scrollIndicator.style.transform = "translate(-50%,0px)";
      scrollMutedIndicator.style.transform = "translate(-50%,0px)";
      // homeTitle.style.transform = "translate(-50%,0px)";
      // homeMutedTitle.style.transform = "translate(-50%,0px)";

      homeOverlay.style.opacity = 0.8;
      homeMutedOverlay.style.opacity = 0;

      this.scene
        .setTween(
          this.tween
            .to(homeOverlay, 5, { opacity: `+=0.1` }, 0)
            .to(homeMutedOverlay, 4, { opacity: `+=0.9` }, 0)
            .to(scrollIndicator, 3, { translateY: `-=${100}` }, 0)
            .to(
              scrollMutedIndicator,
              2,
              { translateY: `-=${100}`, opacity: `+=1` },
              0
            )
        )
        .addTo(this.controller);
      this.longScene
        .setTween(
          this.longTween
            .to(homeTitle, 3, { translateY: `+=${50}`, opacity: `-=1` }, 0)
            .to(homeMutedTitle, 2, { translateY: `+=${50}`, opacity: `+=1` }, 0)
            .to(scrollIndicator, 1, { opacity: `-=1` }, 0)
        )
        .addTo(this.controller);
    },
    destroyParalax() {
      this.controller.destroy();
      this.scene.destroy();
      this.tween.kill();
      this.controller = null;
      this.scene = null;
      this.tween = null;
    },
    debounce(func, wait, immediate) {
      var timeout;
      return function() {
        var context = this,
          args = arguments;
        var later = function() {
          timeout = null;
          if (!immediate) func.apply(context, args);
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
      };
    },
    adjustScrollVolume(player) {
      if (this.muted || !player || !player.player) return;
      let volume = 1 - window.scrollY / 350;
      if (volume > 1) {
        volume = 1;
      } else if (volume < 0) {
        volume = 0;
      }
      player.player.setVolume(volume);
    },
    ...mapActions(["setPrevRouteExists"])
  },

  beforeDestroy() {
    this.destroyParalax();
  },
  mounted() {
    let that = this;
    this.videoID = this.global.mainPage.landing_video.toString();
    if (this.global.mainPage.landing_background) {
      this.bgImage = this.global.mainPage.landing_background;
    }
    this.scene = new ScrollMagic.Scene({
      triggerElement: this.$refs.sectionHome,
      triggerHook: "onLeave",
      duration: 500,
      offset: 0
    });
    this.longScene = new ScrollMagic.Scene({
      triggerElement: this.$refs.sectionHome,
      triggerHook: "onLeave",
      duration: 1400,
      offset: 0
    });
    this.addScrollMagicEffects();

    window.addEventListener("scroll", function() {
      that.adjustScrollVolume(that.$refs.player);
      // that.adjustHiddenOverlay();
    });
  }
};
</script>

<style lang="scss" scoped>
#home-container {
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  .home-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    z-index: 1;
    opacity: 1;
  }
  .home-muted-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #000;
    z-index: 1;
    opacity: 0;
    display: none;
  }
  .home-title {
    position: absolute;
    top: 50%;
    left: 50%;
    right: 0;
    bottom: 0;
    z-index: 2;
    transform: translateX(-50%);
    height: max-content;
    opacity: 1;
    h1 {
      text-align: center;
      text-transform: uppercase;
      font-family: "AvenirLTStd-Roman";
      font-family: var(--name_title_font_family);
      font-size: 24px;
      font-size: var(--name_title_font_size);
      color: var(--main_font);
      letter-spacing: 2px;
      text-align: center;
      z-index: 2;
    }
  }
  #home-muted-title {
    opacity: 0;
    display: none;
  }
  .scroll-indicator {
    position: fixed;
    bottom: 10px;
    left: 50%;
    transform: translateX(-50%);
    min-height: 30px;
    width: 1px;
    z-index: 2;
    opacity: 1;
    cursor: pointer;
    svg {
      height: 60px;
    }
    .scroll-indicator-inner {
      z-index: 2;
      position: relative;
      height: 100%;
      width: 1px;
      background: $new_black;
    }
  }
  #scroll-muted-indicator {
    opacity: 0;
    display: none;
  }
  #home-image {
    height: 100%;
    width: 100%;
    object-fit: cover;
    z-index: -1;
    position: absolute;
  }
  .videoWrapper {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    z-index: -1;
  }
  #home-content {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100vh;
    z-index: -1;
    transition: background 0.9s ease-in-out;
    background: $new_black;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  // #paralax-spacer {
  //   width: 100%;
  //   height: 100vh;
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   z-index: -1;
  //   transition: background 0.9s ease-in-out;
  // }
  .muteButton {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
    position: fixed;
    top: 10px;
    right: 10px;
    z-index: 2;
    .unmuted {
      transition: all 0.5s ease-in-out;
      #static-off-button {
        display: none !important;
      }
      #static-on-button {
        display: block !important;
      }
    }
    // @media (hover: hover) {
    //   &:hover {
    //     transition: all 0.5s ease-in-out;
    //     #static-off-button {
    //       display: none !important;
    //     }
    //     #static-on-button {
    //       display: block !important;
    //     }
    //   }
    // }
    .muteButtonContents {
      position: relative;

      img {
        height: 24px;
        width: 24px;
      }
      svg {
        height: 24px;
        width: 24px;
      }
    }

    cursor: pointer;
  }

  .soundContainer {
    margin-right: 16px;
    height: 40px;
    width: 40px;
    padding: 8.8px;
    border-radius: 50%;
    background: $new_black_rgba;
    transition: all 0.5s ease-in-out;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
    > div {
      top: 50%;
      transform: translateY(-10%);
    }
  }
  .hidden {
    opacity: 0 !important;
    transition: all 0.5s ease-in-out;
  }
  .with-transition {
    transition: all 0.5s ease-in-out;
  }
  .visible {
    display: block !important;
  }
}
</style>
<style lang="scss">
.videoWrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  iframe {
    width: 100vw;
    height: 56.25vw;
    min-height: 100vh;
    min-width: 177.77vh;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>
